import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface OnboardingStatus {
  hasCompletedOnboarding: boolean;
  organizationId: string | null;
  organizationName: string | null;
}

interface CompleteOnboardingDto {
  organizationName?: string;
  role?: 'project_manager' | 'engineering_manager' | 'director' | 'other';
  currentTool?: 'ms_project' | 'smartsheet' | 'excel' | 'other';
  teamSize?: '1-5' | '5-20' | '20-100' | '100+';
  createSampleProject?: boolean;
}

export function useOnboardingStatus() {
  return useQuery({
    queryKey: ['onboarding', 'status'],
    queryFn: async () => {
      const { data } = await api.get<OnboardingStatus>('/onboarding/status');
      return data;
    },
    staleTime: 60_000,
  });
}

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (dto: CompleteOnboardingDto) => {
      const { data } = await api.post<{ success: boolean; projectId?: string }>(
        '/onboarding/complete',
        dto,
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['onboarding'] });
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
